package team.platforma.auth_data.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AuthResponse(
    @SerialName("account") val account: Account,
    @SerialName("jwt") val jwt: Jwt
) {
   @Serializable
   data class Account(
      @SerialName("account_id") val account_id: Long,
      @SerialName("created_at") val created_at: String,
//   @SerialName("deleted_at") val deleted_at: Any,
      @SerialName("email") val email: String,
      @SerialName("first_name") val first_name: String,
      @SerialName("is_admin") val is_admin: Boolean,
      @SerialName("last_name") val last_name: String,
      @SerialName("telegram_chat_id") val telegram_chat_id: Long?
   )

   @Serializable
   data class Jwt(
      @SerialName("refreshToken") val refreshToken: String,
      @SerialName("refreshTokenExpires") val refreshTokenExpires: Long,
      @SerialName("token") val token: String,
      @SerialName("tokenExpires") val tokenExpires: Long
   )
}



